import { FC } from 'react'
import styles from './MainPage.module.scss'

const MainPage: FC = () => {
	return (
		<div className={styles.container}>
			<h1>The main page</h1>

			<div className={styles.article}>
				<h2>1) Tutorial 1</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
				<br />
				<h2>2) Tutorial 2</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
				<br />
				<h2>3) Tutorial 3</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
				<br />
				<h2>4) Tutorial 4</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
				<br />
				<h2>5) Tutorial 5</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
				<br />
				<h2>6) Tutorial 6</h2>
				<p>
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia
					officia veniam ea corrupti, accusantium enim sit soluta doloribus,
					modi molestiae sint voluptatibus! Exercitationem non accusantium
					molestiae alias explicabo quia perferendis! Lorem ipsum dolor sit amet
					consectetur adipisicing elit. Ad iste, laborum autem cum dicta labore
					qui saepe aliquid ut blanditiis optio facere voluptatem laboriosam
					magni quibusdam magnam. Dicta, aliquid perspiciatis.
				</p>
			</div>
		</div>
	)
}

export default MainPage
